module.exports = __webpack_public_path__ + "static/media/46_B.be31f703.png";